(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-buy-buttons"] && !Shopify.designMode) return;
  try {
    // ── Clase product--fully-sold-out + layout agotado en el contenedor PDP ──
  // Se aplica en carga (desde Liquid via data attribute) y se actualiza
  // en tiempo real: primero de forma optimista al clickear un swatch (sin
  // esperar red), y después de forma autoritativa cuando responde el fetch
  // real de la sección (variant:update).
  (function () {
    const pdpGrid = document.querySelector('[data-product-grid-content]');
    const buyButtonsBlock = document.querySelector('.buy-buttons-block');
    if (!pdpGrid || !buyButtonsBlock) return;

    function setFullySoldOut(soldOut) {
      pdpGrid.closest('.product-information')?.classList.toggle('product--fully-sold-out', soldOut);
    }

    // STANLEY FIX: clase hermana de product--fully-sold-out, pero para el
    // caso de precio $0 (no de stock). Mismo tratamiento visual (precio,
    // cuotas y tax-free ocultos vía CSS), separada de "Agotado" para poder
    // mostrar un texto de botón distinto ("No disponible") y no confundir
    // al cliente haciéndole creer que es un problema de stock.
    function setUnavailablePrice(zeroPrice) {
      pdpGrid.closest('.product-information')?.classList.toggle('product--unavailable-price', zeroPrice);
    }

    // Aplica el estado combinado (clases + atributo del botón) de una sola
    // vez. `available` = stock (boolean). `zeroPrice` = precio $0 (boolean).
    // Si ya está agotado por stock, "Agotado" tiene prioridad visual sobre
    // "No disponible" — no mostramos ambos mensajes a la vez.
    function applyDisabledState(available, zeroPrice) {
      const soldOut = available === false;
      const effectiveZeroPrice = !soldOut && !!zeroPrice;

      setFullySoldOut(soldOut);
      setUnavailablePrice(effectiveZeroPrice);

      const btn = buyButtonsBlock.querySelector('button[name="add"]');
      if (!btn) return;

      const shouldDisable = soldOut || effectiveZeroPrice;
      btn.dataset.shouldBeDisabled = shouldDisable ? 'true' : 'false';
      // STANLEY FIX: reforzamos el disabled nativo en el mismo tick, sin
      // depender solo del MutationObserver de más abajo (que corre async).
      // product-form.js hace `.enable()` en base a `available` únicamente
      // (no sabe nada de precio) en su propio listener de variant:update —
      // sin este refuerzo sincrónico queda una ventana breve donde el botón
      // vuelve a ser clickeable pese a data-should-be-disabled="true".
      btn.disabled = shouldDisable;
    }

    // Estado inicial desde data attributes inyectados por Liquid
    const initialAvailable = pdpGrid.dataset.productAvailable !== 'false';
    const initialZeroPrice = buyButtonsBlock.dataset.productZeroPrice === 'true';
    applyDisabledState(initialAvailable, initialZeroPrice);

    // ── Paso 1 (optimista, instantáneo): al clickear un swatch/opción, el
    // picker ya trae `data-option-available` embebido por Liquid en cada
    // input/option — no hace falta esperar el fetch para saber si la nueva
    // combinación estará agotada. Sin esto, el layout viejo (selector de
    // cantidad + botón grande) queda pegado ~1seg hasta que responde la red,
    // y después "flashea" al layout correcto.
    // NOTA: el precio por opción no viaja en data-option-available (solo
    // stock), así que para zeroPrice mantenemos el estado actual hasta que
    // el Paso 2 confirme — evita un falso "disponible" momentáneo si la
    // variante nueva también está en $0.
    document.addEventListener('change', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement) || !target.closest('variant-picker')) return;

      // Mismo criterio que variant-picker.js: ignorar swatches de product
      // cards / quick add, solo nos interesa el picker de esta PDP.
      const isMainPdpVariantPicker =
        window.Theme?.template?.name === 'product' &&
        !target.closest('product-card') &&
        !target.closest('quick-add-dialog');
      if (!isMainPdpVariantPicker) return;

      const selectedOption = target instanceof HTMLSelectElement ? target.selectedOptions[0] : target;
      const optionAvailable = selectedOption?.dataset.optionAvailable;
      if (optionAvailable == null) return;

      const currentZeroPrice = pdpGrid
        .closest('.product-information')
        ?.classList.contains('product--unavailable-price');
      applyDisabledState(optionAvailable === 'true', currentZeroPrice);
    });

    // ── Paso 2 (autoritativo): cuando responde el fetch real, confirma o
    // corrige el estado optimista (por ejemplo, en combinaciones de más de
    // una opción donde `data-option-available` de un solo input no alcanza
    // para saber la disponibilidad exacta de la combinación final, o para
    // confirmar/corregir el precio de la nueva variante).
    document.addEventListener('variant:update', (e) => {
      const available = e.detail?.resource?.available;
      const price = e.detail?.resource?.price;
      if (typeof available !== 'boolean') return;

      // product-form.js hace `morph(button, newButton)` con childrenOnly:true,
      // así que solo sincroniza el contenido interno del botón (spans de
      // texto/ícono) — NO sus propios atributos. El `disabled` nativo se
      // actualiza aparte via addToCartButtonContainer.disable()/.enable()
      // (basado únicamente en `available`, sin noción de precio). Sin esto,
      // data-should-be-disabled queda congelado con el valor de la variante
      // con la que cargó la página, y se desincroniza en el primer cambio.
      applyDisabledState(available, typeof price === 'number' && price <= 0);
    });
  })();

  // ── Guardia anti-apps de terceros (ej. Restock Rocket) ───────────────────
  // Algunas apps escanean el botón "Agregar al carrito" al cargar la página
  // y le sacan el atributo `disabled` nativo (para colgarle su propio click
  // handler). Eso rompe el layout de 2 columnas — que depende de [disabled]
  // — y deja clickeable un botón que debería estar bloqueado.
  //
  // `data-should-be-disabled` es nuestra fuente de verdad (100% controlada
  // por Liquid vía `can_add_to_cart` en la carga inicial, y resincronizada
  // por nosotros mismos en cada `variant:update`, más arriba). El CSS ya usa
  // ese atributo, no [disabled]. Acá solo reforzamos el `disabled` nativo por
  // seguridad funcional: si algo externo se lo saca mientras
  // data-should-be-disabled sigue en "true", se lo volvemos a poner.
  (function () {
    const buttons = document.querySelectorAll('.buy-buttons-block button[name="add"]');

    buttons.forEach((btn) => {
      const observer = new MutationObserver(() => {
        if (btn.dataset.shouldBeDisabled === 'true' && !btn.disabled) {
          btn.disabled = true;
        }
      });
      observer.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
